import LinkButton from '@sats-group/ui-lib/react/link-button';
import Text from '@sats-group/ui-lib/react/text';
import React from 'react';
import FlowLayout from '~/client/components/flow-layout/flow-layout';
import type { Renew as Props } from './renew.types';

const Renew: React.FC<Props> = ({ layout, question, description, options }) => (
  <FlowLayout {...layout}>
    <div className="renew">
      <Text theme={Text.themes.emphasis} size={Text.sizes.large}>
        {question}
      </Text>
      <Text className="renew__description">{description}</Text>
      <div className="renew__options">
        {options.map((option, index) => (
          <LinkButton
            {...option}
            key={option.href}
            size={LinkButton.sizes.basic}
            variant={
              index
                ? LinkButton.variants.secondary
                : LinkButton.variants.primary
            }
            wide
          />
        ))}
      </div>
    </div>
  </FlowLayout>
);

export default Renew;
